import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConfirmationModal, Typography, useOverlayContext } from 'seagull';
import { useStoreActions } from '~/contexts';
import styles from './DeactivateAPIKeyModal.module.scss';
export const DeactivateAPIKeyModal = (param)=>{
    let { apiKey, dismissModal, refresh } = param;
    const { api } = useStoreActions();
    const overlayContext = useOverlayContext();
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        title: "Deactivate API key",
        skin: "danger",
        content: /*#__PURE__*/ _jsxs(Typography, {
            className: styles.deactivateApiKeyModalContent,
            testId: "deactivate-api-key-modal-content",
            children: [
                "Deactivating this API key will immediately block access for any connected platforms or services using it. ",
                /*#__PURE__*/ _jsx("br", {}),
                " ",
                /*#__PURE__*/ _jsx("br", {}),
                " Are you sure you want to deactivate this API key?"
            ]
        }),
        primaryButtonLabel: "Deactivate API key",
        onPrimaryButtonClick: async ()=>{
            try {
                await api.business.deactivateAPIKey(apiKey.id);
                await refresh();
            } catch (error) {
                overlayContext.showErrorToast('Failed to deactivate API key', 'deactivate-api-key-error');
            } finally{
                dismissModal();
            }
        },
        secondaryButtonLabel: "Cancel",
        onSecondaryButtonClick: dismissModal,
        testId: "deactivate-api-key-modal"
    });
};
